// extracted by mini-css-extract-plugin
module.exports = {"headerScrollShadow":"HeaderAprilFools_headerScrollShadow__1cGk7","scrollShadow":"HeaderAprilFools_scrollShadow__cmGrH","scrollBg":"HeaderAprilFools_scrollBg__HnpNI"};